import * as signalR from "@microsoft/signalr";
import { store } from "@/store";
import { env } from "@/env";
import { ICleaning } from "@/models";

const hubUrl = `${env.api.origin}${env.api.hubPath}/cleanings`;
const cleaningsHub = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => store.dispatch("user/getAccessToken") })
    .build();

cleaningsHub.on("CleaningAdded", (cleaning: ICleaning) => {
    store.commit("productionLines/ADD_LAST_CLEANING", cleaning);
});

export { cleaningsHub };
